import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useToast } from "../other/Toast";
import { classNames } from "primereact/utils";
import { useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useHistory } from "react-router";
import SecurityService from "../service/SecurityService";
import ApiService from "../service/apiService";
import { useTranslation } from "react-i18next";
import { Card } from "primereact/card";
import { Calendar as CalendarAD } from "primereact/calendar";
import { adToBs, bsToAd } from "@sbmdkl/nepali-date-converter";
import NepaliDatePicker2 from "../other/nepaliDatePicker";
import { Dropdown } from "primereact/dropdown";
import AdBsDatePicker from "../other/adBsDatePicker";


const ForgotPassword = () => {
  const toast = useToast();
  const history = useHistory();
  const { t } = useTranslation();
  const [email, setEmail] = useState();
  const [permKycId, setPermKycId] = useState();
  const [tempKycId, setTempKycId] = useState();
  const [boid, setBoid] = useState();
  const [dob, setDob] = useState();
  const [dobBs, setDobBs] = useState();
  const [userType, setUserType] = useState();
  const [loading, setLoading] = useState(false);

  const userTypeList = [
    {
      code: "I",
      descEng: "Individual",
      descNep: "Individual",
    },
    {
      code: "C",
      descEng: "Corporate",
      descNep: "Corporate",
    },
  ];

  function isValidDate(date) {
    var regEx = /^\d{4}-\d{2}-\d{2}$/;
    if (!date.match(regEx)) return false; // Invalid format
    var d = new Date(date);
    var dNum = d.getTime();
    if (!dNum && dNum !== 0) return false; // NaN value, Invalid date
    return d.toISOString().slice(0, 10) === date;
  }

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({});
  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  const header = () => (
    <h3 className="p-col-12 p-md-12 text-center">
      <i className="pi pi-user" /> Forgot Password
    </h3>
  );

  const validateEmail = () => {
    console.log("email", email);
    const data = {
      email,
      permKycId,
      tempKycId,
      boid,
      dob,
    };
    if (!permKycId && !tempKycId && !boid) {
      toast.warning("Message", "Provide Permanent Kyc ID or Temporary Kyc ID or BOID")
      return;
    }
    if (!dob) {
      toast.error("Message", "Date of Birth is mandatory")
      return;
    }
    setLoading(true);
    SecurityService.validateForgotPasswordData(data)
      .then((response) => {
        console.log(response.data);
        setLoading(false);
        if (response.data.msg === "success") {
          toast.success("Successful", "A verification code has been sent to your email. Please follow the instructions in the email to reset your password.");
          setTimeout(() => window.location.href = '/reset-password', 5000);

        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error Message", error.response && error.response.data && error.response.data.msg);
      });
  };

  return (
    <div className="compact-layout landing-page-card">
      <div
        style={{
          display: "flex",
          alignContent: "center",
          justifyContent: "center",
          placeContent: "center",
          backgroundColor: "#fff",
        }}
        className="p-col-12"
      >
        <div style={{ padding: 0, paddingBottom: 20 }} className="col-md-12">
          <div
            className="p-grid p-fluid"
            style={{ borderBottom: "1px solid #efefef" }}
          >
            <div
              style={{
                fontSize: 15,
                textAlign: "center",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
                padding: 20,
              }}
              className="p-col-12 p-md-12"
            >
              <img src="./cdsc-Blue-Logo.png" style={{ height: 50 }} />{" "}
              <span
                style={{
                  paddingLeft: 10,
                  fontSize: 36,
                  textAlign: "center",
                  color: "#008080",
                  fontFamily: "'Spectral', serif",
                  transform: "scale(1.25,1)",
                }}
              >
                CKYC
              </span>
            </div>
          </div>
          <form
            style={{ margin: "20px, 0" }}
            onSubmit={handleSubmit(validateEmail)}
          >
            {/* <div className="p-field p-col-12 p-md-12">
              <label className="p-col-12 p-md-12" htmlFor="type">
                {t("userType")}
              </label>
              <div className="p-inputgroup">
                <Controller
                  name="type"
                  control={control}
                  rules={{ required: "Type is required." }}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      id={field.id}
                      value={userType}
                      onChange={(e) => {
                        setUserType(e.value);
                        field.onChange(e.value);
                      }}
                      options={userTypeList}
                      optionLabel="descEng"
                      placeholder={t("selectUserType")}
                      optionValue="code"
                    />
                  )}
                />
              </div>
              {getFormErrorMessage("userType")}
            </div> */}
            <div className="p-field p-col-12 p-md-12">
              <label className="p-col-12 p-md-12" htmlFor="email">
                {t("pleaseEnterTheEmailAssociatedWithYourAccount")}
              </label>
              <div className="p-inputgroup">
                <Controller
                  name="email"
                  control={control}
                  rules={{
                    required: "Email is required.",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                      message: "Provide valid email address",
                    },
                  }}
                  render={({ field, fieldState }) => (
                    <InputText
                      id={field.name}
                      {...field}
                      keyfilter="email"
                      placeholder={t("email")}
                      onChange={(e) => {
                        field.onChange(e.target.value);
                        setEmail(e.target.value);
                      }}
                      className={classNames({
                        "p-invalid": fieldState.invalid,
                      })}
                    />
                  )}
                />
              </div>
              {getFormErrorMessage("email")}
            </div>
            <div className="p-field p-col-12 p-md-12">
              <label className="p-col-12 p-md-12" htmlFor="permKycId">
                {t("permKycId")}
              </label>
              <div className="p-inputgroup">
                <Controller
                  name="permKycId"
                  control={control}
                  //   rules={{required: "Permanent Kyc ID is required.",}}
                  render={({ field, fieldState }) => (
                    <InputText
                      id={field.name}
                      {...field}
                      keyfilter="alphanum"
                      placeholder={t("permKycId")}
                      onChange={(e) => {
                        field.onChange(e.target.value);
                        setPermKycId(e.target.value);
                      }}
                    />
                  )}
                />
              </div>
              {getFormErrorMessage("permKycId")}
            </div>
            <div className="p-field p-col-12 p-md-12">
              <label className="p-col-12 p-md-12" htmlFor="tempKycId">
                {t("tempKycId")}
              </label>
              <div className="p-inputgroup">
                <Controller
                  name="tempKycId"
                  control={control}
                  // rules={{required: "Temporary Kyc ID is required"}}
                  render={({ field, fieldState }) => (
                    <InputText
                      id={field.name}
                      {...field}
                      keyfilter="alphanum"
                      placeholder={t("tempKycId")}
                      onChange={(e) => {
                        field.onChange(e.target.value);
                        setTempKycId(e.target.value);
                      }}
                    />
                  )}
                />
              </div>
              {getFormErrorMessage("tempKycId")}
            </div>
            <div className="p-field p-col-12 p-md-12">
              <label className="p-col-12 p-md-12" htmlFor="boid">
                {t("boid")}
              </label>
              <div className="p-inputgroup">
                <Controller
                  name="boid"
                  control={control}
                  //  rules={{ required: "BOID is required." }}
                  render={({ field, fieldState }) => (
                    <InputText
                      id={field.name}
                      {...field}
                      keyfilter="alphanum"
                      placeholder={t("boid")}
                      onChange={(e) => {
                        field.onChange(e.target.value);
                        setBoid(e.target.value);
                      }}
                    />
                  )}
                />
              </div>
              {getFormErrorMessage("boid")}
            </div>
            <div className="p-grid p-fluid p-col-12">
              <AdBsDatePicker
                css="p-md-6"
                label={t("dateOfBirth")}
                bsDate={dobBs}
                adDate={dob}
                getFormErrorMessageAd={getFormErrorMessage('dateInAd')}
                getFormErrorMessageBs={getFormErrorMessage('dateInBs')}
                onChange={(adDate, bsDate, extra) => {
                  setDob(adDate);
                  setDobBs(bsDate);
                }} />
            </div>
            <div
              className="p-field p-col-12 p-md-12"
              style={{ paddingTop: 20 }}
            >
              <Button label="Submit" className="p-col-12" loading={loading}></Button>
            </div>
            <div
              className="p-field p-col-12 p-md-12"
              style={{ textAlign: "center" }}
            >
              Return back to{" "}
              <a style={{ textDecoration: "none" }} href="/login">
                Login?
              </a>
            </div>
          </form>
        </div>

      </div>
    </div>
  );
};

export default ForgotPassword;
